import CharacteristicType from './CharacteristicType.js';
import Column from './Column.js';
import ColumnMapping from './ColumnMapping.js';
import ColumnDataType from './ColumnDataType.js';
import TimeElement from './TimeElement.js';
import UserLayer from './UserLayer.js';
function configure({ domain, protocol }) {
    const prefix = `${protocol}://${domain}`;
    CharacteristicType.$AR.url = `${prefix}/api/userlayermetadata/v1/user-characteristic-types`;
    Column.$AR.url = `${prefix}/api/userlayermetadata/v1/columns`;
    ColumnMapping.$AR.url = `${prefix}/api/userlayermetadata/v1/column-mappings`;
    TimeElement.$AR.url = `${prefix}/api/userlayermetadata/v1/time-elements`;
    UserLayer.$AR.url = `${prefix}/api/userlayermetadata/v1/user-layers`;
}
const customerMetadata = {
    configure,
    CharacteristicType,
    Column,
    ColumnMapping,
    ColumnDataType,
    TimeElement,
    UserLayer,
};
export { configure, CharacteristicType, Column, ColumnMapping, ColumnDataType, TimeElement, UserLayer, };
/**
 * @namespace customer-metadata
 */
export default customerMetadata;
